var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlinePeoplesBigCircle64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0V0C49.6731 0 64 14.3269 64 32V32C64 49.6731 49.6731 64 32 64V64C14.3269 64 0 49.6731 0 32V32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 34.625C23.99 34.625 17 36.38 17 39.875V42.5H38V39.875C38 36.38 31.01 34.625 27.5 34.625ZM20.51 39.5C21.77 38.63 24.815 37.625 27.5 37.625C30.185 37.625 33.23 38.63 34.49 39.5H20.51ZM27.5 32C30.395 32 32.75 29.645 32.75 26.75C32.75 23.855 30.395 21.5 27.5 21.5C24.605 21.5 22.25 23.855 22.25 26.75C22.25 29.645 24.605 32 27.5 32ZM27.5 24.5C28.745 24.5 29.75 25.505 29.75 26.75C29.75 27.995 28.745 29 27.5 29C26.255 29 25.25 27.995 25.25 26.75C25.25 25.505 26.255 24.5 27.5 24.5ZM38.06 34.715C39.8 35.975 41 37.655 41 39.875V42.5H47V39.875C47 36.845 41.75 35.12 38.06 34.715V34.715ZM36.5 32C39.395 32 41.75 29.645 41.75 26.75C41.75 23.855 39.395 21.5 36.5 21.5C35.69 21.5 34.94 21.695 34.25 22.025C35.195 23.36 35.75 24.995 35.75 26.75C35.75 28.505 35.195 30.14 34.25 31.475C34.94 31.805 35.69 32 36.5 32Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlinePeoplesBigCircle64Px);
export default __webpack_public_path__ + "static/media/ic_outline-peoples_big_circle-64px.e3a1a4ae3924d49c5274ff6bcc1ecf18.svg";
export { ForwardRef as ReactComponent };